"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FUND_ABBREVIATIONS = exports.FUND_NAMES = void 0;
exports.FUND_NAMES = {
    FUND_1_CA: 'Fund 1 - CA',
    FUND_1_MO: 'Fund 1 - MO',
    FUND_2: 'Fund 2',
    WAREHOUSE: 'Warehouse',
    GP_SEED_FUND_1: 'GP Seed Fund I, L.P.',
    HREP_III: 'Homevest Real Estate Partners III, L.P.',
    HREP_IV: 'Homevest Real Estate Partners IV - Limestone, L.P.',
    GP_SEED_FUND_II: 'Homevest GP Seed Fund II, L.P.',
    F4_KC: 'Homevest Fund IV KC, LP'
};
exports.FUND_ABBREVIATIONS = {
    FUND_1_CA: 'F1 CA',
    FUND_1_MO: 'F1 MO',
    FUND_2: 'F2',
    WAREHOUSE: 'WH',
    GP_SEED_FUND_1: 'F1GPS',
    HREP_III: 'HREP III',
    HREP_IV: 'HREP IV - L',
    GP_SEED_FUND_II: 'F2GPS',
    F4_KC: 'F4 KC'
};
